import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {INavigationType} from "../../../navigation.interface";
import {AbstractControl, FormBuilder, FormControl, Validators} from "@angular/forms";
import {FormUtils} from "../../../../../../../shared/utils/form-utils";
import {RemoveItemDialogComponent} from "../../../../products/remove-item-dialog/remove-item-dialog.component";
import {DialogService} from "../../../../../../../../ng2-bootstrap-modal/dialog.service";
import {MenuItemCategories} from "../../../navigation.enum";
import {DbValidators} from "../../../../../../../shared/validators/DbValidators";
import {DbModalService} from "../../../../../../../modules/modal/modal";
import {NavigationService} from "../../../navigation.service";

@Component({
    selector: 'db-edit-ecommerce-navigation-item',
    templateUrl: './edit-ecommerce-navigation-item.component.html',
    styleUrls: ['./edit-ecommerce-navigation-item.component.scss'],
    standalone: false
})
export class EditEcommerceNavigationItemComponent implements OnInit {
  menuItem: INavigationType;

  @Input('menuItem') set menuForm(item: INavigationType) {
    this.menuItem = item;
    if (this.menuItem.object_type === 'custom') {
      this.addUrlForm();
    }
    this.menuItemForm.patchValue({
      navigationLabel: this._navigationService.decodeHtml(item.title),
      url: item.url
    });
  }

  @Input() types: MenuItemCategories;

  @Output() deleteItem: EventEmitter<INavigationType> = new EventEmitter<INavigationType>();
  @Output() saveItem: EventEmitter<INavigationType> = new EventEmitter<INavigationType>();

  menuItemForm: any = this._fb.group({
    navigationLabel: [null, [Validators.required, Validators.pattern(/.*\S.*/)]],
  });

  constructor(private _fb: FormBuilder,
              private _modalService: DbModalService,
              private _navigationService: NavigationService,
              private _dialogService: DialogService) {
  }

  ngOnInit() {
  }

  onDeleteItem() {
    const alternativePopup = {
      title: "Delete this item",
      description: "Are you sure you want to delete this item?",
      button: "Delete"
    };
    const modal = this._modalService.open(RemoveItemDialogComponent);
    modal.componentInstance.alternativePopup = alternativePopup;
    modal.closed
      .subscribe(value => {
        if (value) {
          this.deleteItem.emit(this.menuItem);
        }
      });
  }

  onSaveItem(event) {
    event.stopPropagation();
    if (this.menuItemForm.invalid) {
      new FormUtils().markAllAsTouched(this.menuItemForm);
      return;
    }
    if (this.menuItem.object_type === 'custom') {
      this.menuItem.url = this.menuItemForm.get('url').value;
    }
    this.menuItem.title = this.menuItemForm.get('navigationLabel').value;
    this.saveItem.emit(this.menuItem);
  }

  addUrlForm() {
    const formControl: AbstractControl = new FormControl(null, [DbValidators.trim, Validators.required]);
    this.menuItemForm && this.menuItemForm.addControl('url', formControl);
  }

}
